import { sprintf, translate } from '../../../../../utils/i18n';
import { APPROVAL_TOOL_NAMES } from '../../../constants';
import BaseToolParams from './base_tool_params';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

var script = {
  name: 'DefaultToolParams',
  components: {
    BaseToolParams
  },
  props: {
    toolName: {
      type: String,
      required: false,
      default: ''
    },
    toolParams: {
      type: Object,
      required: true
    }
  },
  computed: {
    title() {
      var _this$toolParams;
      return (_this$toolParams = this.toolParams) === null || _this$toolParams === void 0 ? void 0 : _this$toolParams.title;
    },
    description() {
      var _this$toolParams2, _this$toolParams3, _this$toolParams4;
      return ((_this$toolParams2 = this.toolParams) === null || _this$toolParams2 === void 0 ? void 0 : _this$toolParams2.description) || ((_this$toolParams3 = this.toolParams) === null || _this$toolParams3 === void 0 ? void 0 : _this$toolParams3.body) || ((_this$toolParams4 = this.toolParams) === null || _this$toolParams4 === void 0 ? void 0 : _this$toolParams4.comment);
    },
    isNote() {
      return [APPROVAL_TOOL_NAMES.createMergeRequestNote, APPROVAL_TOOL_NAMES.createWorkItemNote, APPROVAL_TOOL_NAMES.createIssueNote].includes(this.toolName);
    },
    message() {
      const message = this.title ? this.$options.i18n.TITLE_MESSAGE : '';
      return sprintf(message, {
        ...this.toolParams
      });
    },
    accordionTitle() {
      return this.isNote ? this.$options.i18n.NOTE_ACCORDION_TITLE : '';
    },
    displayRawOutput() {
      return !this.message;
    }
  },
  i18n: {
    TITLE_MESSAGE: translate('IssuableToolParams.TITLE_MESSAGE', 'Set the title "<em>%{title}</em>".'),
    NOTE_ACCORDION_TITLE: translate('IssuableToolParams.NOTE_ACCORDION_TITLE', "Read note's content")
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-tool-params',{attrs:{"with-json-view":"","tool-params":_vm.toolParams,"message":_vm.message,"description":_vm.description,"custom-accordion-title":_vm.accordionTitle}})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
